import { FieldType } from '@ngx-formly/material/form-field';

import { Component } from '@angular/core';

import { ISnToggleTooltipFormFieldConfig } from '../../interfaces/toggle-tooltip-form-field-config.interface';
import { ISnToggleTooltipTemplateOptions } from '../../interfaces/toggle-tooltip-template-options.interface';

@Component({
  selector: 'sn-toggle-tooltip-form-field',
  templateUrl: './toggle-tooltip.form-field.html',
  styleUrls: ['./toggle-tooltip.form-field.scss'],
})
export class SnToggleTooltipFormField extends FieldType<ISnToggleTooltipFormFieldConfig> {
  public readonly defaultOptions: ISnToggleTooltipFormFieldConfig = {
    type: 'toggle-tooltip',
    defaultValue: false,
    templateOptions: {
      tooltipPosition: 'right',
      tabindex: 0,
      labelPosition: 'after',
      tooltipIcon: 'info',
    },
  };

  constructor() {
    super();
  }

  get templateOptions(): ISnToggleTooltipTemplateOptions {
    return this.field.templateOptions;
  }
}
